import React, { Fragment, useState } from "react";
import Editor from "../Editor/Editor";
import List, { ListPropsType } from "./List";
import { Preview } from "../Editor/Fields/belongsTo/File";
import { Button, Modal, Space } from "@mantine/core";
import Translation from "../Utils/Translation";
import { IconInfoSquare } from "@tabler/icons-react";

const ImageWithPreview = ({ value }) => {
    const [opened, setOpened] = useState(false);
    let previews = null;
    if (value?.length) {
        previews = (
            <>
                <Modal
                    size="100%"
                    title={<Translation base={[]} id="preview" />}
                    opened={opened}
                    centered
                    overlayProps={{
                        blur: 1,
                    }}
                    onClose={() => setOpened(false)}
                >
                    <div className="punch-knife-preview">
                        {value?.map((file) => (
                            <Fragment key={file.id}><Preview key={file.id} file={file} /><Space h="md" /></Fragment>
                        ))}
                    </div>
                </Modal>
                <Button
                    onClick={() => setOpened(true)}
                >
                    <IconInfoSquare />
                </Button>
            </>
        );
    }
    return (
        <>
            {previews}
        </>
    );
}

export default React.forwardRef<any, Partial<ListPropsType & { [key: string]: any }>>((props, ref) => {
    return <List
        ref={ref}
        component="PunchingKnife"
        order={{ field: "created_at", direction: "DESC" }}
        fields={{
            "actions": {
                header: (_props) => {
                    return <Editor
                        {..._props}
                        children={null}
                        onSaved={() => {
                            _props.setState({ ..._props.state });
                        }}
                    />
                },
                filterable: false,
                sortable: false,
                width: 1,
                formatter: (_props) => {
                    return <>
                        <Editor
                            {..._props}
                            values={_props.data}
                            {...{ [_props.config.idfield]: _props?.data?.[_props.config.idfield] }}
                            onSaved={() => {
                                _props.setState({ ..._props.state });
                            }}
                            onRemoved={() => {
                                _props.setState({ ..._props.state });
                            }}
                            children={null}
                        />
                    </>;
                }
            },
            "preview": {
                formatter: ImageWithPreview,
                width: 1,
            },
            "serialnumber": {
                filterable: true,
                sortable: true,
                width: 1,
            },
            "name": {
                filterable: true,
                sortable: true,
            },
            "width": {
                filterable: true,
                sortable: true,
                width: 1,
            },
            "height": {
                filterable: true,
                sortable: true,
                width: 1,
            },
            "wave_direction": {
                filterable: true,
                sortable: true,
                width: 1,
            },
            "storage_space": {
                filterable: true,
                sortable: true,
                width: 1,
            },
            "project": {
                filterable: true,
                sortable: true,
                width: 1,
                formatter: ({ value }) => value?.label,
            },
        }}
        {...props}
    />;
});
